var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVipIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.684,
    height: 20.37,
    viewBox: "0 0 19.684 20.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.198,
    x2: 0.858,
    y2: 0.875,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#faa15b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edbe55"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u51CF\\u53BB\\u9876\\u5C42",
    className: "cls-1",
    d: "M13.8,20.37H5.881A5.268,5.268,0,0,1,.613,15.417L0,4.89a1.043,1.043,0,0,1,.358-.851,1.079,1.079,0,0,1,.7-.261,1.011,1.011,0,0,1,.2.019l3.065.61a1.057,1.057,0,0,0,.219.023,1.039,1.039,0,0,0,.739-.307L9.094.316a1.043,1.043,0,0,1,1.5,0L14.4,4.122a1.07,1.07,0,0,0,.74.306,1.008,1.008,0,0,0,.209-.022l3.076-.61a1.007,1.007,0,0,1,.2-.019,1.08,1.08,0,0,1,.7.261,1.048,1.048,0,0,1,.358.851L19.06,15.417A5.261,5.261,0,0,1,13.8,20.37ZM7.275,8.893a.99.99,0,0,0-.7,1.691l2.806,2.8a.994.994,0,0,0,1.4,0l2.806-2.8a.991.991,0,0,0-1.4-1.4l-2.105,2.1-2.1-2.1A.987.987,0,0,0,7.275,8.893Z",
    transform: "translate(0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipIcon2);
export default __webpack_public_path__ + "static/media/vip_icon2.5cccdbd5ef47180c392a2ee624d64a6f.svg";
export { ForwardRef as ReactComponent };